import { parkingCredentialsService } from "services/parkingCredentialsService";


function mimeToExt(mime) {
    const map = {
      'application/pdf': 'pdf',
      'image/png': 'png',
      'image/jpeg': 'jpg',
      'text/plain': 'txt',
    };
    return map[mime] ?? 'bin';
  }
  
  export const blobToFile = (blob, id) => {
    if (blob === null) {
        return null;
    }
    const name = id ?? `attachment.${mimeToExt(blob.type)}`;
    return new File([blob], name, { type: blob.type, lastModified: Date.now() });
  }

export const downloadFile = async (id) => {
    const blob = await parkingCredentialsService.attachment(id);
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    const ext = mimeToExt(blob.type);
    const fileName = `${id}.${ext}`;
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}

export const printFile = async (id) => {
    const blob = await parkingCredentialsService.attachment(id);
    const url = URL.createObjectURL(blob);
    const win = window.open(url);
    win?.print();
}
